module.exports = __webpack_public_path__ + "e1bdb19b2bd946e554b9c78766bc1975.svg";